export const footerLinks = [
  {
    label: "Privacy Policy",
    href: "/privacy-policy",
    external: false,
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/hungerford-consulting/",
    external: true,
  },
];
